import renderField from 'components/Field/reduxForm';
import Loading from 'components/Loading';
import { find, noop, values } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'redux-form/immutable';
import AutoCompleteRenderer from './AutoCompleteRenderer';
import './styles.scss';

const defaultErrorText = 'Ошибка загрузки данных. Попробуйте повторить позже';
const VALUE_MIN_LENGTH = 3;
const ITEMS_LIMIT = 10;

export default class Autocomplete extends Component {
  static propTypes = {
    getOptions: PropTypes.func.isRequired,
    autofill: PropTypes.func.isRequired,
    onSelect: PropTypes.func, //receives option or null
    validate: PropTypes.func,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    isRequired: PropTypes.bool,
    isDisabled: PropTypes.bool,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    valueMinLength: PropTypes.number,
    requestArgs: PropTypes.object,
    selectable: PropTypes.bool, //only select
    notFoundErrorMessage: PropTypes.string,
    tooltipContent: PropTypes.string,
    tooltipTitle: PropTypes.string,
    isResetOnChange: PropTypes.bool,
    onBlur: PropTypes.func,
    hasHelpWrap: PropTypes.bool,
    normalize: PropTypes.func,
    maxLength: PropTypes.any,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    valueMinLength: VALUE_MIN_LENGTH,
    isRequired: null,
    isDisabled: null,
    validate: null,
    requestArgs: null,
    selectable: true,
    className: 'form_item form_item__part',
    label: null,
    notFoundErrorMessage: 'Ничего не найдено',
    onSelect: noop,
    isResetOnChange: true,
    maxLength: null,
  };

  state = {
    showAutocomplete: false,
    loading: false,
    error: null,
    currentRequest: null,
    options: null,
    selectedOption: null,
    inputValue: '',
    componentIsFocused: false,
  };

  loadOptions = (value) => {
    const { getOptions, requestArgs } = this.props;
    const request = getOptions(value, requestArgs);
    this.setState(
      {
        loading: true,
        error: null,
        options: null,
        currentRequest: request,
        selectedOption: null,
      },
      () => {
        request.options
          .then((options) => {
            this.setState({
              loading: false,
              currentRequest: null,
              options: options,
            });
          })
          .catch((error) => {
            this.setState({
              loading: error.isCanceled ? this.state.loading : false,
              currentRequest: error.isCanceled ? this.state.currentRequest : null,
              error: error.isCanceled ? null : defaultErrorText,
            });
          });
      },
    );
  };

  startLoadOptions = (value) => {
    const { currentRequest } = this.state;
    if (currentRequest) {
      currentRequest.cancel();
    }

    this.loadOptions(value);
  };

  onSelectOption = (option) => {
    const { autofill, name, onSelect } = this.props;
    this.setState(
      {
        showAutocomplete: false,
        selectedOption: option,
      },
      () => {
        autofill(name, option.value);
        onSelect(option);
      },
    );
  };

  handleChange = (e, value) => {
    const { valueMinLength, onChange } = this.props;
    if (onChange) {
      onChange(value);
    }
    this.setState({
      inputValue: value,
      selectedOption: null,
    });

    if (!value || value.length < valueMinLength) {
      if (this.state.showAutocomplete) {
        this.setState({
          showAutocomplete: false,
        });
      }
      return;
    }

    this.setState({ showAutocomplete: true }, () => {
      this.startLoadOptions(value);
    });
  };

  handleClickOutside = (e) => {
    const { autofill, name, onSelect, selectable, valueMinLength, isResetOnChange } = this.props;
    const { showAutocomplete, inputValue, selectedOption } = this.state;
    if (e.target.id === name) {
      return e.type === 'blur' && e.preventDefault(); // stop blur event of redux-form
    }
    const needReset = isResetOnChange
      ? !selectedOption && (showAutocomplete || inputValue.length < valueMinLength)
      : inputValue.length < valueMinLength;

    if (needReset) {
      const option = find(this.state.options, (option) => option.value === inputValue);
      selectable && autofill(name, '');
      onSelect(selectable ? null : option || inputValue);
    }
    this.setState({ showAutocomplete: false, componentIsFocused: false });
  };

  handleBlur = (e, inputValue = '') => {
    const {
      autofill,
      name,
      onSelect,
      selectable,
      valueMinLength,
      onBlur,
      isResetOnChange,
    } = this.props;
    const needReset = isResetOnChange && selectable && inputValue.length < valueMinLength;
    if (needReset) {
      autofill(name, null);
      onSelect(null);
      e && e.preventDefault(); // stop blur event of redux-form
    }
    if (onBlur) {
      onBlur();
    }
    /**Что бы форма не валидировала onBlur если выбираем значение из списка
     * а вообще нужны требования и новый компонент, дефекты так и будут плодиться*/
    !isResetOnChange && this.state.showAutocomplete && e.preventDefault();
  };

  handleFocus = () => {
    this.setState({ componentIsFocused: true });
  };

  formatValue = (option) => {
    let result = option.label || option.value;
    if (option.additionalFields) {
      const fields = values(option.additionalFields);
      result = [result, ...fields].join(', ');
    }
    return result;
  };

  renderOptions = () => {
    const { options, error } = this.state;
    if (error) {
      return <div className="Select-info red">{error}</div>;
    }

    if (!options) {
      return null;
    }

    if (!options.length) {
      return <div className="Select-info red">{this.props.notFoundErrorMessage}</div>;
    }

    const tooLongest = options.length > ITEMS_LIMIT;
    let items = options.slice(0, ITEMS_LIMIT).map((option, key) => {
      return (
        <div
          className="Select-option"
          key={`autocomplete-option_${key}`}
          onClick={() => this.onSelectOption(option)}
        >
          {this.formatValue(option)}
        </div>
      );
    });

    if (tooLongest) {
      const info = (
        <div className="Select-info">
          <div className="link link_attention">
            Найдено слишком много результатов. Уточните запрос
          </div>
        </div>
      );
      items = [info, ...items];
    }

    return items;
  };

  renderLoading = () => {
    return (
      <div className="loading-container loading-container__big">
        <Loading />
      </div>
    );
  };

  render() {
    const {
      name,
      label,
      placeholder,
      isRequired,
      validate,
      isDisabled,
      className,
      tooltipContent,
      tooltipTitle,
      hasHelpWrap,
      normalize,
      maxLength,
    } = this.props;
    const { showAutocomplete } = this.state;
    return (
      <div>
        <Field
          name={name}
          label={label}
          isRequired={isRequired}
          placeholder={placeholder || null}
          component={renderField}
          validate={validate}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          isDisabled={isDisabled}
          className={className}
          hasHelpWrap={hasHelpWrap}
          normalize={normalize}
          maxLength={maxLength}
          children={
            showAutocomplete ? (
              <AutoCompleteRenderer
                loading={this.state.loading}
                renderLoading={this.renderLoading}
                renderOptions={this.renderOptions}
                handleClickOutside={this.handleClickOutside}
              />
            ) : null
          }
          autoComplete="off"
          tooltipContent={tooltipContent || null}
          tooltipTitle={tooltipTitle || null}
        />
      </div>
    );
  }
}
